import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Footer } from "../components/Footer.js";
import { Account_head } from "./../components/account_head.js";
import { get_order_list } from "../service/api.js";
import Head_CateHead from '../components/Head_CateHead.js';

// Current Orders: orders that are NOT Dispatched and NOT Complete
const COMPLETED_STATUSES = ["DISPATCHED", "COMPLETE"];

export const Acc_current_orders = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const data_get = async () => {
        try {
            const res = await get_order_list();
            const all = res?.data?.Data ?? [];
            // Filter to only active/current orders
            const current = all.filter(
                (item) => !COMPLETED_STATUSES.includes(item.Status)
            );
            setData(current);
        } catch (error) {
            console.error("Error fetching current orders:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (localStorage.getItem('token')) {
            data_get();
        } else {
            navigate("/signin");
        }
    }, []);

    const viewOrder = (id) => {
        navigate(`/order_detail/${id}`);
    };

    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return '—';
        const options = {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };
        return new Intl.DateTimeFormat('en-GB', options).format(new Date(dateTimeString));
    };

    return (
        <div className='order_list_main'>
            <Head_CateHead />
            <Account_head title_="Current Orders" />
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: '40px' }}>
                    <p style={{ fontSize: '18px' }}>Loading...</p>
                </div>
            ) : data.length > 0 ? (
                <div className="sign_in_wrapper container account w-75">
                    <table width="100%" className='order_list_table'>
                        <thead>
                            <tr>
                                <th>Order Id</th>
                                <th>Order Placed On</th>
                                <th>Status</th>
                                <th>Payment</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={item.OrderID ?? index}>
                                    <td
                                        style={{ cursor: 'pointer', color: '#01AEF0' }}
                                        onClick={() => viewOrder(item.OrderID)}
                                    >
                                        #{item.OrderID}
                                    </td>
                                    <td>{formatDateTime(item.CreatedOn)}</td>
                                    <td>{item.Status || '—'}</td>
                                    <td>
                                        {["IN PRODUCTION", "DISPATCHED", "COMPLETE"].includes(item.Status) ? (
                                            <strong style={{ color: "#198754" }}>PAID</strong>
                                        ) : (
                                            <strong style={{ color: "#dc3545" }}>NOT PAID</strong>
                                        )}
                                    </td>
                                    <td>${item.Totalprice}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div style={{ textAlign: 'center', marginTop: '-20px' }}>
                    <p style={{ fontSize: '30px' }}>No current orders.</p>
                    <br />
                    <Link to="/shop"><button className="spe_ex_button">Shop</button></Link>
                    <br />
                    <br />
                    <br />
                </div>
            )}
            <Footer />
        </div>
    );
};
